import { Spinner } from "react-bootstrap";

const Spinnerr = ({ show = false }) => {
  if (!show) return null;

  return (
    <div className="fps-overlay">
      <Spinner animation="border" className="fps-spinner" />
    </div>
  );
};

export default Spinnerr;
